import IButtonData from "../../shared/interfaces/button.interface";
import IInputData from "../../shared/interfaces/input.interface";

export const SIGN_IN_BUTTON: IButtonData[] = [
	{
		id: 'sign_in',
        variant: 'contained',
        color: 'error',
        // href: 'https://fitpal.co',
        textButton: "Ingresar",
        size:'small'
	}
]

export const DEFAULT_VALUES_INPUT = {
    username: "",
    password: ""
}

export const INPUTS_FORM: IInputData[] = [
    {
        name: "username",
        label: "Usuario",
        size: "small",
        helperText: "Escribe el nombre de usuario",
        variant: "outlined",
        required: true
    },
    {
        name: "password",
        label: "Contraseña",
        size: "small",
        helperText: "Escribe tu contraseña",
        type: "password",
        variant: "outlined",
        required: true
    }
];
